import styled from 'styled-components';
import { LoadingIndicator } from '@m/alchemy-ui/LoadingIndicator';
import { units } from '@m/alchemy-ui/theme';

const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  margin: ${units(1)} 0;
  justify-content: center;
`;

export function CenteredLoadingIndicator({ style = {} }: { style?: React.CSSProperties }) {
  return (
    <LoadingContainer style={style}>
      <LoadingIndicator inline />
    </LoadingContainer>
  );
}
